module.exports = __webpack_public_path__ + "static/media/stats_background_orange.64ff8398.svg";